import { memo, useEffect } from "react";
import { PropTypes } from "prop-types";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import { sendTagDepositNoteViewed } from "app/utils/analytics";

import "./PayNowNote.scss";
import PaymentCardGroupIcon from "app/pages/.shared/static/icons/PaymentCardGroupIcon";
import PaymentModesTooltipContainer from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentModes/PaymentModesTooltipContainer";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";

const PayNowNote = ({
	total,
	depositPercentage,
	availablePaymentMethods = [],
	displayAmountSuffix = true,
}) => {
	useEffect(() => {
		sendTagDepositNoteViewed();
	}, []);

	if (!depositPercentage) {
		return false;
	}

	const payNow = Math.ceil((total * depositPercentage) / 100);

	const note = (
		<FormattedMessage
			id="my.bookings.pay.now.note.amount"
			tagName="span"
			values={{
				amount: (
					<AmountContainer
						amount={payNow}
						suffix={
							displayAmountSuffix && (
								<FormattedMessage id="general.amount.per.person.suffix.label.short" />
							)
						}
					/>
				),
			}}
		/>
	);

	return (
		<div className="pay-now-note" data-testid="pay-now-note">
			<PaymentCardGroupIcon width={16} height={16} />
			{note}
			<FloatingButton
				position="bottom"
				floatingContent={
					<PaymentModesTooltipContainer paymentModes={availablePaymentMethods} />
				}
				referenceComponent={<IconInfo width={12} height={12} />}
			/>
		</div>
	);
};

PayNowNote.propTypes = {
	total: PropTypes.number,
	depositPercentage: PropTypes.number,
	availablePaymentMethods: PropTypes.array,
	displayAmountSuffix: PropTypes.bool,
};

export default memo(PayNowNote);
